import { Loading } from '@ui-kit';
import { useTranslation } from 'react-i18next';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
}

export default function LoadingSpinner({ fullScreen = true, size = 'md' }: LoadingSpinnerProps) {
  const { t } = useTranslation('common');
  return <Loading fullScreen={fullScreen} size={size} label={t('states.loading')} />;
}
